import cx from 'clsx';
import Link from 'next/link';
import { useState } from 'react';

import {
  ImageWithFallbackArticle,
} from '@/components/image-with-fallback-article';

import {
  ARTICLE_DESKTOP_IMAGE_HEIGHT,
  ARTICLE_DESKTOP_IMAGE_WIDTH,
  ARTICLE_MOBILE_IMAGE_HEIGHT,
  ARTICLE_MOBILE_IMAGE_WIDTH,
} from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const Articles: Component = ({
  carRelatedArticles,
  isDesktopMode,
}) => {
  const imageWidth = isDesktopMode
    ? ARTICLE_DESKTOP_IMAGE_WIDTH
    : ARTICLE_MOBILE_IMAGE_WIDTH;

  const imageHeight = isDesktopMode
    ? ARTICLE_DESKTOP_IMAGE_HEIGHT
    : ARTICLE_MOBILE_IMAGE_HEIGHT;

  const [hoveredId, setHoveredId] = useState<number | null>(null);

  return (
    <div className={styles.containerRoot}>
      {carRelatedArticles.map(article => (
        <div
          key={article.id}
          className={styles.containerArticle}>
          <Link
            href={article.link}
            onMouseEnter={() => setHoveredId(article.id)}
            onMouseLeave={() => setHoveredId(null)}>
            <ImageWithFallbackArticle
              alt={article.title}
              className={styles.imageVehicleCover}
              height={imageHeight}
              src={article.thumbnail}
              width={imageWidth} />
          </Link>
          <div>
            <Link
              className={cx(
                styles.linkTitle,
                hoveredId === article.id && styles.isHovered,
              )}
              href={article.link}>
              {article.title}
            </Link>
            <div className={styles.textDescription}>
              {article.description}
            </div>
            <div className={styles.textMake}>
              { article.category && (
                <div className={styles.textItem}>
                  {article.category?.toUpperCase()}
                  {'  '}
                  {article.type?.toUpperCase()}
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
